'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import type { CookieType } from '@personly/libs-types';
import { TextSelect } from '@personly/libs-widgets';
import { useConsents } from '@/providers/consents';
interface Props {
  cookieTypes: CookieType[];
}
const CookieTypeSelect = t0 => {
  const $ = _c(9);
  const {
    cookieTypes
  } = t0;
  const {
    selectedCookieType,
    setSelectedCookieType
  } = useConsents();
  let t1;
  if ($[0] !== setSelectedCookieType) {
    t1 = cookieType => setSelectedCookieType(cookieType);
    $[0] = setSelectedCookieType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClick = t1;
  let t2;
  if ($[2] !== cookieTypes || $[3] !== onClick || $[4] !== selectedCookieType) {
    let t3;
    if ($[6] !== onClick || $[7] !== selectedCookieType) {
      t3 = cookieType_0 => <div key={cookieType_0.handle}>{cookieType_0.handle === selectedCookieType.handle ? <TextSelect>{cookieType_0.title}</TextSelect> : <div className="cursor-pointer" onClick={() => onClick(cookieType_0)}>{cookieType_0.title}</div>}</div>;
      $[6] = onClick;
      $[7] = selectedCookieType;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = cookieTypes.map(t3);
    $[2] = cookieTypes;
    $[3] = onClick;
    $[4] = selectedCookieType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default CookieTypeSelect;